import "core-js/modules/es.array.concat.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1a105657"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "faq__container"
};
var _hoisted_2 = {
  "class": "faq"
};
var _hoisted_3 = {
  "class": "faq__title-container"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "faq__title"
  }, "F.A.Q.", -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "faq__subtitle"
  }, "Frequently Asked Questions", -1);
});
var _hoisted_6 = {
  "class": "faq__content"
};
var _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"faq__directory\" data-v-1a105657><div class=\"faq_headline\" data-v-1a105657>Directory</div><ul data-v-1a105657><li data-v-1a105657><a href=\"#faqFeatures\" data-v-1a105657>Features &amp; AIVitar Settings</a></li><li data-v-1a105657><a href=\"#faqSubscription\" data-v-1a105657>Subscription</a></li><li data-v-1a105657><a href=\"#faqLanguage\" data-v-1a105657>Language Support</a></li><li data-v-1a105657><a href=\"#faqDocuments\" data-v-1a105657>Documents</a></li></ul></div><div class=\"faq_headline\" data-v-1a105657>Search</div>", 2);
var _hoisted_9 = {
  key: 0,
  "class": "faq_search-active"
};
var _hoisted_10 = {
  key: 1
};
var _hoisted_11 = {
  "class": "faq__items",
  id: "faqFeatures"
};
var _hoisted_12 = {
  key: 0,
  "class": "faq_headline"
};
var _hoisted_13 = {
  key: 0
};
var _hoisted_14 = ["innerHTML"];
var _hoisted_15 = ["innerHTML"];
var _hoisted_16 = {
  key: 0,
  style: {
    "font-weight": "bold",
    "margin-left": "20px",
    "margin-top": "10px",
    "margin-bottom": "10px",
    "color": "#666"
  }
};
var _hoisted_17 = ["src", "alt"];
var _hoisted_18 = {
  key: 1,
  "class": "faq_headline",
  id: "faqSubscription"
};
var _hoisted_19 = {
  key: 0
};
var _hoisted_20 = ["innerHTML"];
var _hoisted_21 = ["innerHTML"];
var _hoisted_22 = {
  key: 0,
  style: {
    "font-weight": "bold"
  }
};
var _hoisted_23 = ["src", "alt"];
var _hoisted_24 = {
  key: 2,
  "class": "faq_headline",
  id: "faqDocuments"
};
var _hoisted_25 = {
  key: 0
};
var _hoisted_26 = ["innerHTML"];
var _hoisted_27 = ["innerHTML"];
var _hoisted_28 = {
  key: 0,
  style: {
    "font-weight": "bold"
  }
};
var _hoisted_29 = ["src", "alt"];
var _hoisted_30 = {
  key: 3,
  "class": "faq_headline",
  id: "faqLanguage"
};
var _hoisted_31 = {
  key: 0
};
var _hoisted_32 = ["innerHTML"];
var _hoisted_33 = ["innerHTML"];
var _hoisted_34 = {
  key: 0,
  style: {
    "font-weight": "bold"
  }
};
var _hoisted_35 = ["src", "alt"];
var _hoisted_36 = {
  key: 0
};
var _hoisted_37 = {
  "class": "faq__question"
};
var _hoisted_38 = {
  "class": "faq__answer"
};
var _hoisted_39 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  var _component_ButtonBasic = _resolveComponent("ButtonBasic");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-times",
    beat: "",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$store.commit('updateShowFAQ', false);
    }),
    "class": "fas fa-check faq-close"
  }), _createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createVNode(_component_ButtonBasic, {
    "class": "faq__button",
    label: "Close",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$store.commit('updateShowFAQ', false);
    })
  })]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _withDirectives(_createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.faqSearch = $event;
    }),
    placeholder: "Search F.A.Q.s with keywords",
    "class": "faq__search"
  }, null, 512), [[_vModelText, _ctx.faqSearch]]), _ctx.faqSearch ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Showing results for \"" + _toDisplayString(_ctx.faqSearch) + "\" ", 1)) : _createCommentVNode("", true), _ctx.isSearching && _ctx.faqSearch ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-refresh",
    spin: "",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.faqSearch = '';
    }),
    "class": "fas fa-times"
  }), _createTextVNode(" Searching... ")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [!_ctx.hideNonSearch ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Features & AIVitar Settings ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, function (faq, faqIndex) {
    return _openBlock(), _createElementBlock("div", {
      "class": "faq__item",
      key: "featuresFAQ".concat(faqIndex)
    }, [faq.subject == 'features' && (!_ctx.faqSearch || _ctx.faqSearch && _ctx.containsWords(faq)) ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", {
      "class": "faq__question",
      innerHTML: faq.question
    }, null, 8, _hoisted_14), _createElementVNode("div", {
      "class": "faq__answer",
      innerHTML: faq.answer
    }, null, 8, _hoisted_15), faq.images && faq.images.length ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Images to help guide you: ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.images, function (image, imageIndex) {
      return _openBlock(), _createElementBlock("div", {
        "class": "faq__images",
        key: "".concat(faq.subject).concat(imageIndex)
      }, [_createElementVNode("img", {
        "class": "faq__image",
        src: image,
        alt: "faqImage".concat(imageIndex)
      }, null, 8, _hoisted_17)]);
    }), 128))])) : _createCommentVNode("", true)]);
  }), 128)), !_ctx.hideNonSearch ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Billing Subscription ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, function (faq, faqIndex) {
    return _openBlock(), _createElementBlock("div", {
      "class": "faq__item",
      key: "subscription".concat(faqIndex)
    }, [faq.subject == 'subscription' && (!_ctx.faqSearch || _ctx.faqSearch && _ctx.containsWords(faq)) ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", {
      "class": "faq__question",
      innerHTML: faq.question
    }, null, 8, _hoisted_20), _createElementVNode("div", {
      "class": "faq__answer",
      innerHTML: faq.answer
    }, null, 8, _hoisted_21), faq.images && faq.images.length ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Images to help guide you: ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.images, function (image, imageIndex) {
      return _openBlock(), _createElementBlock("div", {
        "class": "faq__images",
        key: "".concat(faq.subject).concat(imageIndex)
      }, [_createElementVNode("img", {
        "class": "faq__image",
        src: image,
        alt: "faqImage".concat(imageIndex)
      }, null, 8, _hoisted_23)]);
    }), 128))])) : _createCommentVNode("", true)]);
  }), 128)), !_ctx.hideNonSearch ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Documents ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, function (faq, faqIndex) {
    return _openBlock(), _createElementBlock("div", {
      "class": "faq__item",
      key: "documents".concat(faqIndex)
    }, [faq.subject == 'documents' && (!_ctx.faqSearch || _ctx.faqSearch && _ctx.containsWords(faq)) ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", {
      "class": "faq__question",
      innerHTML: faq.question
    }, null, 8, _hoisted_26), _createElementVNode("div", {
      "class": "faq__answer",
      innerHTML: faq.answer
    }, null, 8, _hoisted_27), faq.images && faq.images.length ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Images to help guide you: ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.images, function (image, imageIndex) {
      return _openBlock(), _createElementBlock("div", {
        "class": "faq__images",
        key: "".concat(faq.subject).concat(imageIndex)
      }, [_createElementVNode("img", {
        "class": "faq__image",
        src: image,
        alt: "faqImage".concat(imageIndex)
      }, null, 8, _hoisted_29)]);
    }), 128))])) : _createCommentVNode("", true)]);
  }), 128)), !_ctx.hideNonSearch ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Languages Supported ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, function (faq, faqIndex) {
    return _openBlock(), _createElementBlock("div", {
      "class": "faq__item",
      key: "languages".concat(faqIndex)
    }, [faq.subject == 'languages' && (!_ctx.faqSearch || _ctx.faqSearch && _ctx.containsWords(faq)) ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", {
      "class": "faq__question",
      innerHTML: faq.question
    }, null, 8, _hoisted_32), _createElementVNode("div", {
      "class": "faq__answer",
      innerHTML: faq.answer
    }, null, 8, _hoisted_33), faq.images && faq.images.length ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Images to help guide you: ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.images, function (image, imageIndex) {
      return _openBlock(), _createElementBlock("div", {
        "class": "faq__images",
        key: "".concat(faq.subject).concat(imageIndex)
      }, [_createElementVNode("img", {
        "class": "faq__image",
        src: image,
        alt: "faqImage".concat(imageIndex)
      }, null, 8, _hoisted_35)]);
    }), 128))])) : _createCommentVNode("", true)]);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportedLanguages, function (language, languageIndex) {
    return _openBlock(), _createElementBlock("div", {
      "class": "faq__item",
      key: "language".concat(languageIndex)
    }, [!_ctx.faqSearch || _ctx.faqSearch && _ctx.containsWords({
      question: "Does this have language support for ".concat(language, "?"),
      answer: "Yes! ".concat(language, " should be supported for both speaking to/with and typing to/with AIVitars. However, since A.I. models contain a ton of data and features we have tested some and not all. Additionally, the menu and text on the application might not support button text and content other than the conversations with the AI model for now. There might also be an issue when the model tries to speak each language. It might not come across as correct pronounciation. Contact us if you experience this and wish to have assistance in resolving this or language menu option requests at ").concat(_ctx.$store.state.supportEmailLink, ".")
    }) ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, " Does this have language support for " + _toDisplayString(language) + "? ", 1), _createElementVNode("div", _hoisted_38, [_createTextVNode(" Yes! " + _toDisplayString(language) + " should be supported for both speaking to/with and typing to/with AIVitars. However, since A.I. models contain a ton of data and features we have tested some and not all. Additionally, the menu and text on the application might not support button text and content other than the conversations with the AI model for now. There might also be an issue when the model tries to speak each language. It might not come across as correct pronounciation. Contact us if you experience this and wish to have assistance in resolving this or language menu option requests at ", 1), _createElementVNode("span", {
      innerHTML: _ctx.$store.state.supportEmailLink
    }, null, 8, _hoisted_39), _createTextVNode(". ")])])) : _createCommentVNode("", true)]);
  }), 128))])])])]);
}